import PropTypes from 'prop-types';
import { useState } from 'react';
import { HeaderTitle } from '../common/HeaderTitle/HeaderTitle';
import CreatePlanModal from '../common/Modal/PlanModal/CreatePlanModal';
import TableHeader from '../common/table/TableHeader';
import PlanFliters from './PlanFilter';
import PlansTable from './PlansTable';

const PlansContent = ({ fetchData, onCreateGame, pageCount }) => {
  const [isFilter, setFilter] = useState(false);
  const [isCreateModal, setCreateModal] = useState(false);

  const onToggleFilter = () => {
    setFilter(!isFilter);
  };

  const onToggleCreateModal = () => {
    setCreateModal(!isCreateModal);
  };
  return (
    <div className="w-full">
      <HeaderTitle pageTitle={'Plans'} />
      <div className="mt-10">
        <div className="relative shadow-lg p-5 bg-[#ffffff] rounded-xl w-[97%] mx-auto border-[1px]">
          <TableHeader
            FileName="Plans"
            addButtonEnable={true}
            onToggleFilter={onToggleFilter}
            modalOpenfunc={onToggleCreateModal}
          />
          <div
            className={`absolute w-[23rem] mt-2 p-2 bg-slate-400 rounded-md right-0 z-10 ${
              isFilter ? 'block' : 'hidden'
            }`}
          >
            <PlanFliters onToggleFilter={onToggleFilter} />
          </div>
          <PlansTable fetchData={fetchData} pageCount={pageCount} />
        </div>
      </div>
      {isCreateModal && (
        <CreatePlanModal
          isModalOpen={isCreateModal}
          onToggleModal={onToggleCreateModal}
          onSubmit={onCreateGame}
        />
      )}
    </div>
  );
};
PlansContent.propTypes = {
  fetchData: PropTypes.func,
  onCreateGame: PropTypes.func,
  pageCount: PropTypes.number,
};
export default PlansContent;
